// <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
// <path d="M12.75 20.5C16.064 20.5 18.75 18.5 18.75 15C18.75 13.5 18.25 11 16.25 9C16.5 10.5 15 11 15 11C15.75 8.5 13.75 5 10.75 4.5C11.107 6.5 11.25 8.5 8.75 10.5C7.5 11.5 6.75 13.229 6.75 15C6.75 18.5 9.436 20.5 12.75 20.5ZM12.75 19.5C11.093 19.5 9.75 18.5 9.75 16.75C9.75 16 10 14.75 11 13.75C10.875 14.5 11.75 15 11.75 15C11.375 13.75 12.25 11.75 13.75 11.5C13.571 12.5 13.5 13.5 14.75 14.5C15.375 15 15.75 15.864 15.75 16.75C15.75 18.5 14.407 19.5 12.75 19.5Z" fill="#405368"/>
// </svg>

import React from 'react';
import { SvgIcon } from '../../../../components/svgIcon';
import { SvgIconProps } from '../../../../components/svgIcon/model';

export const ClockNineIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="career/properties/nannies/ClockNineIcon" ref={ref as any} {...props}>
      <path
        d="M12.5 5.5C8.375 5.5 5 8.875 5 13C5 17.125 8.375 20.5 12.5 20.5C16.625 20.5 20 17.125 20 13C20 8.875 16.625 5.5 12.5 5.5ZM13.25 13C13.25 13.45 12.95 13.75 12.5 13.75H8.375C7.925 13.75 7.625 13.45 7.625 13C7.625 12.55 7.925 12.25 8.375 12.25H11.75V8.3125C11.75 7.8625 12.05 7.5625 12.5 7.5625C12.95 7.5625 13.25 7.8625 13.25 8.3125V13Z"
        fill="#405368"
      />
    </SvgIcon>
  );
});
